import { FileStatus, DocumentTypes, FileMetadata } from 'types';
import { FileErrors, FileFlags, type FileMergeMetadata as MergedFileData } from '@verify/shared-utils';

export type ApiFetchMultipleFiles = {
  id: string;
  originalFilename: string;
  originalPath?: string;
  filename: string;
  path?: string;
  signedUrl: string;
  status: FileStatus.completed | FileStatus.error;
  createdAt: string;
  updatedAt: string;
  error: FileErrors | null;
}[];

export interface UploadedFile {
  id: string;
  originalFilename: string;
  originalPath?: string;
  filename: string;
  path?: string;
  signedUrl: string;
  createdAt: string;
  updatedAt: string;
  status: FileStatus.completed;
}

export interface FailedFile {
  id: string;
  filename: string;
  error: FileErrors;
}

export enum PendingFileStatus {
  uploading = 'uploading',
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}

export interface PendingFile {
  id: string;
  originalFilename: string;
  status: PendingFileStatus;
  progress?: number; // 0-100 for upload progress
  error?: FileErrors;
}

export type FetchMultipleFilesData = {
  uploadedFiles: UploadedFile[];
  failedFiles: FailedFile[];
  documentType: DocumentTypes;
};

export type ApiPollFilesStatus = boolean;

export type ApiUploadMultipleFiles = (
  | {
      id: string;
      filename: string;
      path: string;
      userId: string;
    }
  | FailedFile
)[];

export type ApiMergeFiles = {
  id: string;
  filename: string;
  originalFilename: '';
  originalPath: '';
  path: '';
  status: FileStatus.pending;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

interface FileResponse {
  id: string;
  flags: FileFlags[];
  originalFileId: string;
  originalFilename: string;
  originalPath?: string;
  filename: string;
  mergedMetadata: MergedFileData[];
  path?: string;
  signedUrl: string;
  status: FileStatus;
  createdAt: string;
  updatedAt: string;
  error: FileErrors | null;
  fileMetadata?: FileMetadata;
}

export type APIStartOCR = FileResponse;
export type APIFetchOCR = FileResponse;
